'use client'

import { useMutation } from "@tanstack/react-query"
import { API_Error, API_Success_Response } from "@/interfaces/api/response/api_response_types"
import { promoCode } from "../requests/purchases"

export const usePromoCode = () => useMutation<API_Success_Response, API_Error, string>({
  retry: false,
  mutationFn: promoCode
})